import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["max_width", "background", "padding", "backgroundOpacity", "children", "className"];
import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { useMaxWidthClasses, usePaddingClasses } from "../shared-classes";
import { jsx as _jsx } from "react/jsx-runtime";
export var Row = _ref => {
  var {
    max_width,
    background,
    padding,
    backgroundOpacity,
    children,
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = useRowClass({
    max_width,
    background,
    padding,
    backgroundOpacity
  });
  return /*#__PURE__*/_jsx("section", _extends({
    className: clsx(classes, className)
  }, rest, {
    children: children
  }));
};
var useRowClass = createMemoClass(props => {
  var padding = usePaddingClasses(props.padding);
  var max_width = useMaxWidthClasses(props.max_width);
  var backgrounds = {
    primary: "text-primary bg-primary",
    secondary: "text-secondary bg-secondary",
    tertiary: "text-tertiary bg-tertiary",
    neutral: "text-neutral bg-neutral",
    "blue-to-green": "text-white bg-gradient-to-r from-ccq-blue to-green",
    "blue-to-dark-blue": "text-white bg-gradient-to-r from-ccq-blue to-ccq-dark-blue"
  };
  var backgroundOpacities = {
    10: "bg-opacity-10",
    20: "bg-opacity-20",
    30: "bg-opacity-30",
    40: "bg-opacity-40",
    50: "bg-opacity-50",
    60: "bg-opacity-60",
    70: "bg-opacity-70",
    80: "bg-opacity-80",
    90: "bg-opacity-90"
  };
  var classes = clsx("w-full mx-auto", padding, max_width, backgrounds[props.background], backgroundOpacities[props.backgroundOpacity] || "");
  return classes;
});
//# sourceMappingURL=row.js.map